import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css'],
})
export class AlertModalComponent implements OnInit {
  readonly modalData: Record<string, any> = {};
  userAction: string;
  closeButtonText: string;
  useCopyButton: boolean;
  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.closeButtonText = this.modalData.closeButtonText != null ? this.modalData.closeButtonText : 'Close';
    this.useCopyButton = this.modalData.useCopyButton == true && this.modalData.modalMessage != null;
  }

  async copyClicked(): Promise<void> {
    const clipboardItem = new ClipboardItem({ ['text/plain']: this.modalData.modalMessage });
    await navigator.clipboard.write([clipboardItem]);
  }

  cancelClicked(): void {
    this.userAction = 'close';
    this.bsModalRef.hide();
  }
}
